module.exports = __webpack_public_path__ + "static/mr-concert-performance-30-275676ae032fea71dd8f0fccfdc5293d.jpg";